export default function Title(props) {
  const { Tag, text, highlighted } = props;

  return (
    <Tag className="h1 text-dark font-normal leading-none max-w-6xl mx-auto text-center">
      {text}
      <span className="font-bold">{highlighted}</span>
    </Tag>
  );
}
